'use client';

import { motion, useMotionValue, useSpring } from 'motion/react';
import * as React from 'react';

const TILT_AMOUNT = 7;
const SPRING_CONFIG = { stiffness: 300, damping: 30 };

export function TiltCard({ children }: React.ComponentProps<typeof motion.div>): React.ReactNode {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const xSpring = useSpring(x, SPRING_CONFIG);
  const ySpring = useSpring(y, SPRING_CONFIG);

  const handleMouseMove = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      const { clientX, clientY, currentTarget } = event;
      const rect = currentTarget.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const relativeX = (clientX - centerX) / rect.width;
      const relativeY = (clientY - centerY) / rect.height;
      x.set(relativeX * TILT_AMOUNT);
      y.set(-relativeY * TILT_AMOUNT);
    },
    [x, y],
  );

  const handleMouseLeave = React.useCallback(() => {
    x.set(0);
    y.set(0);
  }, [x, y]);

  return (
    <motion.div
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        perspective: '1000px',
        transformStyle: 'preserve-3d',
      }}
    >
      <motion.div
        style={{
          rotateX: ySpring,
          rotateY: xSpring,
          transformStyle: 'preserve-3d',
          pointerEvents: 'none',
        }}
      >
        <div style={{ pointerEvents: 'auto' }}>{children as React.ReactNode}</div>
      </motion.div>
    </motion.div>
  );
}
